import { render, staticRenderFns } from "./SignWapiti.vue?vue&type=template&id=4c514d3c&scoped=true&"
import script from "./SignWapiti.vue?vue&type=script&lang=js&"
export * from "./SignWapiti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c514d3c",
  null
  
)

export default component.exports